import moment from 'moment';
import { createDeepEqualSelector } from './';

export const projectsSelector = (state: any) => state.projects;

moment().utc().format('YYYY-MM-DD HH:mm:ss');

export const isProjectModalOpenSelector = createDeepEqualSelector(
  projectsSelector,
  (projects) => projects.isProjectModalOpen,
);

export const projectModalEventLocationSelector = createDeepEqualSelector(
  projectsSelector,
  (projects) => projects.projectModalEventLocation,
);
